export const config = {
  stage: process.env.STAGE,
  isProductionStage: process.env.STAGE === "production",
  isBrowserDebugStage: process.env.STAGE === "browserdebug",
  isGraylogEnabled: process.env.ENABLE_GRAYLOG === "true",
  host: process.env.HOST,
};
